import * as Yup from 'common/yup';
import {ServerTypes, ServerTypesEnum} from 'types/ServerType';
import i18n from 'i18n';
import {passphrase} from 'common/yup/customs/passphrase';

export const portSchema = () =>
   Yup.number()
      .min(-1, i18n.t('Must be greater than or equal to 0'))
      .max(65535, i18n.t('Must be less than or equal to 65535'));

export const ServerNames = {
   type: 'type',
   address: 'address',
   port: 'port',
   domain: 'domain',
   username: 'username',
   password: 'password',
   directory: 'directory',
   timeout: 'timeout',
};
export const AbstractServer = Yup.object({
   // typeName: serverTypeNameSchema.default(ServerTypeName.LOCAL),
   type: Yup.string()
      .oneOf(ServerTypes.keys)
      .when('directory', (dir: string, schema: Yup.StringSchema) =>
         dir
            ? schema.test(
                 i18n.t('Server supports directory'),
                 i18n.t('Directory cannot be specified with this server'),
                 (value: ServerTypesEnum) => ServerTypes[value].supportsDir
              )
            : schema
      )
      .default(ServerTypes.keys[0]),
   address: Yup.string(),
   port: portSchema().default(-1),
   domain: Yup.string(),
   username: Yup.string(),
   password: passphrase(),
   directory: Yup.string(),
   timeout: Yup.number(),
});

export type Server = Yup.InferType<typeof AbstractServer>;
